<template>
  <div>
    <v-dialog v-model="openModal">
      <div class="d-flex justify-end align-center pl-11">
        <v-avatar class="icon-image" :style="` border: 4px solid ${color}`">
          <img :src="`/assets/${point.type}.png`" />
        </v-avatar>
      </div>
      <v-card>
        <v-toolbar flat :style="`border-top: 13px solid ${color};`">
          <v-card-title>
            <h2 :class="`${point.type}--text`">{{ point.name }}</h2>
          </v-card-title>
          <v-spacer />
          <v-btn icon @click="openModal = false" color="darkGray">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text></v-card-text>
        <v-spacer />
        <v-card-text class="d-flex justify-center flex-column">
          <v-row>
            <v-col class="d-flex justify-start align-center">
              <v-icon class="pl-4" :color="color">mdi-map-marker</v-icon>
              <span class="font-weight-bold pl-3">מקום:</span>
              <span> {{ point.locationName }}</span>
              <span v-if="point.inDispute">(?)</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex justify-start align-center">
              <v-icon class="pl-4" :color="color">mdi-flag</v-icon>
              <span class="font-weight-bold pl-3">נחלה:</span>
              <span> {{ areas }}</span>
            </v-col>
          </v-row>
          <v-row @click="openLinks({ item: point.verses, type: 'verse' })" class="mouse-pointer"
            v-if="point.verses.length">
            <v-col class="d-flex justify-start align-center">
              <v-icon class="pl-4" :color="color">mdi-book-open-variant</v-icon>
              <span>לחצו כאן לצפייה בפסוקים</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex justify-start align-start">
              <v-icon class="pl-4" :color="color">mdi-subtitles</v-icon>
              <div style="flex-direction: column">
                <span class="font-weight-bold pl-3">תקציר:</span>
                <span>
                  {{ point.info }}
                </span>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="d-flex justify-start align-start" v-if="toggleRead">
              <v-icon class="pl-4" :color="color">mdi-script-text-outline</v-icon>
              <div style="flex-direction: column">
                <span class="font-weight-bold pl-3">הֶסבֵּר:</span>
                <span>
                  {{ point.description }}
                </span>
              </div>
            </v-col>
            <v-col>
              <div class="d-flex justify-end" v-if="point.description">
                <v-btn text class="tanachiDark--text" @click="toggleRead = !toggleRead">
                  <v-icon v-if="toggleRead">mdi-chevron-right</v-icon>
                  <span>{{ toggleRead? "קרא פחות": "קרא עוד" }}</span>
                  <v-icon v-if="!toggleRead">mdi-chevron-left</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-divider class="my-5" v-if="linksLength" />
          <div v-if="linksLength">
            <div open-delay="0" v-for="field in fieldsLink" :key="field.icon">
              <v-row @click="openLinks(field)" class="mouse-pointer" v-if="field.item.length">
                <v-col class="d-flex justify-start align-center" cols="12">
                  <v-icon x-large color="tanachiDark" class="pl-4">
                    mdi-{{ field.icon }}
                  </v-icon>
                  <span class="text-decoration-underline" v-text="field.text" />
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <links-handler v-if="openLinksDialog" v-model="openLinksDialog" :links="currentLinks" :type="type" />
  </div>
</template>
<script>
import LinksHandler from "./LinksHandler.vue"
import pointsTypes from "@/templates/pointsTypes"
export default {
  name: "point-handler",
  components: {
    LinksHandler,
  },
  props: {
    value: Boolean,
    point: { type: Object, default: () => ({}) },
  },
  data(props) {
    const { videos, medias, games, audios } = props.point
    return {
      toggleRead: false,
      pointsTypes,
      fieldsLink: [
        {
          item: videos,
          type: "video",
          color: "",
          text: "צפו בוידאו",
          icon: "play-circle-outline",
        },
        {
          item: audios,
          type: "audio",
          color: "",
          text: "האזינו לפודקאסט",
          icon: "volume-medium",
        },
        {
          item: medias,
          type: "media",
          color: "",
          text: "צפו בתמונות",
          icon: "image",
        },
        {
          item: games,
          type: "game",
          color: "",
          text: "שחקו במשחק",
          icon: "controller",
        },
      ],
      type: null,
      currentLinks: [],
      openLinksDialog: false,
    }
  },
  computed: {
    openModal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      },
    },
    linksLength() {
      return this.fieldsLink.filter((field) => field?.item?.length).length
    },
    color() {
      let color =
        this.pointsTypes?.find((p) => p.value === this.point.type).color || ""
      return color
    },
    areas() {
      let result = ""
      const areas = this.point?.areas
      if (areas.length === 1) {
        result = this.areaById(areas[0])
      } else {
        areas.forEach((element, i) => {
          result +=
            i < areas.length - 1
              ? this.areaById(element) + " או "
              : this.areaById(element)
        })
      }
      return result
    },
  },
  methods: {
    openLinks({ item, type }) {
      if (!item.length) return
      this.type = type
      this.currentLinks = item
      this.openLinksDialog = true
    },
    areaById(id) {
      const area = this.$store.getters.areaById(id)
      return area?.title
    },
  },
  watch: {
    openLinksDialog() {
      if (!this.openLinksDialog) {
        this.currentLinks = []
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.icon-image {
  position: absolute;
  z-index: 1;
}
</style>
